<template>
  <v-container grid-list-md fluid class="pt-0 pb-0">
    <v-card class="pa-2 card-r grey lighten-5">
      <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
        <!--<router-link to="/"><v-icon class="text-white left pr-3">keyboard_arrow_left</v-icon></router-link>-->
        <div class="text-xs-left f-20">Packages</div>
        <v-spacer></v-spacer>
        <div class="text-xs-right pa-2">
          <v-btn class="ma-0 right white text-primary card-r no-shadow" to="createpackage">Add Package</v-btn>
        </div>
        <div class="text-xs-left pa-2 text-xs-right">
          <v-btn class="ma-0 white text-primary card-r no-shadow" @click="filterPackages()">Import Packages</v-btn>
        </div>
      </v-toolbar>
    </v-card>
      <v-card class="mt-2 no-shadow transparent">

        <v-layout row wrap class="">
          <v-flex d-flex lg4 sm6 xs12 v-for="(i,index) in adminpackages" :key="`1${index}`">
            <v-card class="select-pack-card pa-3 no-shadow card-r ">
              <v-toolbar class="tow-clor-1 card-r shadow-1 pl-3 text-white">
                <v-btn v-bind:to="'viewpackage/'+i.id" class="no-shadow card-r ma-0 white text-capitalize font-weight-bold">view
                  <v-icon class="select-pack-color blue-grey--text pl-3">visibility</v-icon></v-btn>
                <v-spacer></v-spacer>
                <v-btn class="ma-0 mr-2 white shadow-1 card-r mr-2" icon v-bind:to="'editpackage/'+i.id">
                  <v-icon class="select-pack-color blue-grey--text">edit</v-icon></v-btn>
                <!-- <v-btn class="ma-0 shadow-1 white card-r mr-2" icon @click="deleted = true">
                  <v-icon class="select-pack-color blue-grey--text">delete</v-icon></v-btn> -->
              </v-toolbar>
              <v-toolbar flat xs12 class="transparent">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                  <div class="text-xs-center pl-4 f-20 font-weight-bold blue-grey--text">{{i.name}}</div>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down"></v-toolbar-items>
              </v-toolbar>
              <v-flex xs12 class="text-xs-right pa-0">
              </v-flex>
              <v-layout xs12>
                <v-flex xs12 class="text-xs-center grey--text pt-0 pb-0">
                  <p class="f-14 word-break">{{i.description}}</p>
                </v-flex>
              </v-layout>
              <!-- <v-layout xs12>
                <v-flex xs6 class="text-xs-center pa-0">
                  <span class="font-weight-bold f-15 blue-grey--text">Total Hours -</span>
                </v-flex>
                <v-flex xs6 class="text-xs-center pa-0">
                  <span class="font-weight-bold f-15">{{i.hours}} Hours</span>
                </v-flex>
              </v-layout> -->
              <v-layout xs12 class="mb-3">
                <v-flex xs6 class="text-xs-center pa-0">
                  <span class="font-weight-bold f-15 blue-grey--text">Total Cost -</span>
                </v-flex>
                <v-flex xs6 class="text-xs-center pa-0">
                  <span class="font-weight-bold f-15">KR {{i.cost}}</span>
                </v-flex>
              </v-layout>
              <v-layout xs12>
                <v-flex xs6 class="text-xs-right pa-0">
                  <!-- <ConfirmDelete/> -->
                  <!--<v-btn icon> <v-icon class="select-pack-color right blue-grey--text">delete</v-icon></v-btn>-->
                </v-flex>

              </v-layout>

              <!--<v-btn class="no-shadow card-r w-100 ma-0 primary text--white btnM">Select</v-btn>-->
            </v-card>
          </v-flex>

        </v-layout>
      </v-card>
    <v-dialog v-model="deleted" max-width="290">
      <v-card class="card-r">
        <v-card-title class="f-17 text-capitalize">Are You Sure Want To Delete <span class="font-weight-bold f-17">Package</span>?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="grey text-white left card-r" text @click="deleted = false">No</v-btn>
          <v-btn class="primary text-white card-r" text @click="deleted = false">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="DownloadPackagePopup" max-width="525">
      <v-card class="no-shadow pa-3 card-r">
        <div  class="text-xs-center">
          <v-toolbar class="primary darken-2 card-r shadow-1 pl-3 text-white">
            <div class="text-xs-left f-20">Import Packages</div>
          </v-toolbar>
        </div>
        <v-layout>
          <v-flex>
            <v-flex xs12 class="pt-2">
              <v-list>
                <v-card color="lighten-2" class="pa-0 ma-0 card-r no-shadow"  v-if="!loading">
                  <div v-for="val in filteredPackages" v-if="filteredPackages.length!=0">
                    <v-checkbox class="pa-0 ma-0" v-model="selectedPackages" :label="val.name" :value="val.id"></v-checkbox>
                  </div>
                  <div v-if="filteredPackages.length==0">
                    <v-alert :value="true" type="info">
                      There are no classes found
                    </v-alert>
                  </div>
                </v-card>
                <!-- <BulletListLoader v-if="loading" :width="250" :height="100"></BulletListLoader> -->
                <v-flex xs12 class="text-xs-center mr-1">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                    v-if="loading"
                  ></v-progress-circular>
                </v-flex>
              </v-list>
            </v-flex>
            <v-flex xs12 class="text-xs-left mr-1">
              <v-alert v-if="alertType" :type="alertType" :value="true">
                {{msg}}
              </v-alert>
            </v-flex>
            <v-layout xs12>
              <v-flex xs12 class="text-xs-right">
                <v-btn @click="DownloadPackagePopup = false" class="grey text-white card-r">Cancel</v-btn>
                <v-btn @click="importPackages(), dialog = false" class="card-r primary darken-2 text-white card-r">Import</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<style>
  .lll{
    border: 1px solid gray!important;
  }
  .v-dialog{
    box-shadow: none!important;
  }
</style>
<script>
  /* eslint-disable */
  import { mapState , dispatch } from "vuex"
  import ConfirmDelete from './ConfirmDelete'
  import api from "@/utils/backend-api"

  export default {
    components:{
      ConfirmDelete
    },
    data: () => ({
      loading:false,
      deleted: false,
      show: false,
      dialog: false,
      DownloadPackagePopup:'',
      filteredPackages:[],
      selectedPackages:[],
      PackagesList: "",
      alertType:'',
      msg:'',
      return: {
        items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
          }
        ]
      }
    }),

    methods:{
      loadPopup(){
        // let self=this
        // api.postData('admin/viewOtherClubs')
        // .then(res=>{
        //   self.Clubs=res.data
        // }).catch(err=>{

        // })
        this.loading=true
        this.filterPackages()
        this.DownloadPackagePopup=true
      },

      filterPackages(){
        this.loading=true
        let self=this
        this.DownloadPackagePopup=true
        api.postData('admin/viewPackageTemplate')
          .then(res=>{
            self.filteredPackages=res.data
            this.loading=false
          }).catch(err=>{
          self.filteredPackages=[]
          this.loading=false
        })
        this.selectedPackages=[]
      },


      importPackages(){
        let self=this
        this.loading=true
        api.postData('admin/copyPackage',{package_template_id:this.selectedPackages})
          .then(res=>{
            this.alertType="success"
            this.msg="Successfully imported"
            self.loadClubPackages()
            this.loading=false
            setTimeout(()=>{
              self.DownloadPackagePopup=false
            },1200);
          }).catch(err=>{
          this.loading=false
          this.alertType="error"
          this.msg="Import failed"
        })
      },


      //loadClubPackages()
      loadClubPackages(){
        Store.dispatch("Packages/getAllPackages")
          .then(res => {
            this.PackagesList = res;
            Store.commit("setLoading", { loading: false });
          })
          .catch(() => {
            Store.commit("setLoading", { loading: false });
          });
      },


    },

    mounted:()=>{
      Store.dispatch('Packages/getAllPackages').then(res=>{
      })

    },

    computed:{
      ...mapState({
        adminpackages:adminpackages => Store.state.Packages.adminpackages
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/package/Packages.vue